import { createSlice } from '@reduxjs/toolkit'

import { CalendarState } from 'src/@types/calendar'
import authSlice from '../auth/slice'

const initialState: CalendarState = {
  isLoading: false,
  error: null,
  events: [],
  isOpenModal: false,
  selectedEventId: null,
  selectedRange: null,
}

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },

    // GET EVENTS
    getEventsSuccess(state, action) {
      state.isLoading = false
      state.events = action.payload
    },

    // CREATE EVENT
    createEventSuccess(state, action) {
      const newEvent = action.payload
      state.isLoading = false
      state.events = [...state.events, newEvent]
    },

    // UPDATE EVENT
    updateEventSuccess(state, action) {
      const event = action.payload
      const updateEvent = state.events.map((_event) => {
        if (_event.id === event.id) {
          return event
        }
        return _event
      })

      state.isLoading = false
      state.events = updateEvent
    },

    // DELETE EVENT
    deleteEventSuccess(state, action) {
      const { eventId } = action.payload
      const deleteEvent = state.events.filter((event) => event.id !== eventId)
      state.events = deleteEvent
    },

    // SELECT EVENT
    selectEvent(state, action) {
      const eventId = action.payload
      state.isOpenModal = true
      state.selectedEventId = eventId
    },

    // SELECT RANGE
    selectRange(state, action) {
      const { start, end } = action.payload
      state.isOpenModal = true
      state.selectedRange = { start, end }
    },

    // OPEN MODAL
    openModal(state) {
      state.isOpenModal = true
    },

    // CLOSE MODAL
    closeModal(state) {
      state.isOpenModal = false
      state.selectedEventId = null
      state.selectedRange = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(authSlice.actions.signOut, (state) => {
      return initialState
    })
  },
})

export default calendarSlice
